import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import { useDispatch, connect } from "react-redux";
import analytics from "web/script/analytics/analytics";
import { languageIsEnglish } from "web/script/modules/language";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";
import { gettext } from "web/script/modules/django-i18n";
import { setDesktopBannerVisible } from "web/redux/ducks/app-download-banner";
import userProfiler from "web/script/modules/userprofiler";
import CookieBanner from "web/react/components/cookie-banner/cookie-banner";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import AppDownloadBannerDesktop from "web/react/components/app-download-banner-desktop/app-download-banner-desktop";
import withReduxProvider from "web/react/redux-provider";
import styles from "./banner-container.css";

function mapStateToProps(state) {
  var _state$followDesigner = state.followDesignerBannerReducer,
      feedProfile = _state$followDesigner.profile,
      showDUBanner = _state$followDesigner.show,
      disableDUBanner = _state$followDesigner.bannerDisable;
  var desktopAppBannerVisible = state.appDownloadBannerReducer.desktopBannerVisible;
  return {
    feedProfile: feedProfile,
    showDUBanner: showDUBanner,
    disableDUBanner: disableDUBanner,
    desktopAppBannerVisible: desktopAppBannerVisible
  };
}

export function BannerContainer(_ref) {
  var cookieBanner = _ref.cookieBanner,
      feedProfile = _ref.feedProfile,
      showDUBanner = _ref.showDUBanner,
      disableDUBanner = _ref.disableDUBanner,
      desktopAppBannerVisible = _ref.desktopAppBannerVisible;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isIos = _useState2[0],
      setIsIos = _useState2[1];

  var dispatch = useDispatch();
  useEffect(function () {
    setIsIos(browser.ios); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [browser.ios]);
  dispatch(setDesktopBannerVisible(analytics.getInitialPageType() === "feed" && !!environment.getFeature("mg_app_desktop_banner_feeds") && !feedProfile.brand_ad && !userProfiler.hasAppBannerBeenDismissed() && browser.getViewport() === browser.VIEWPORTS.DESKTOP && !isIos));
  var pageSubType = environment.get("pageSubType");
  var enableIosToApp = environment.getFeature("mg_du_banner_ios_to_app");
  var isOnDesignerFeed = pageSubType && pageSubType.startsWith("designer");
  var sendIOSUsersToApp = isIos && enableIosToApp && isOnDesignerFeed;
  var followButtonProps = feedProfile.follow_button ? {
    lystId: feedProfile.follow_button.lyst_id,
    isAuthenticated: feedProfile.follow_button.is_authenticated,
    isFollowing: feedProfile.follow_button.is_following,
    description: sendIOSUsersToApp ? feedProfile.follow_button.ios_sticky_description : "",
    notFollowedText: enableIosToApp && isOnDesignerFeed ? // 'Get Designer Updates'
    gettext("designer_updates.get_designer_updates_btn_text") : feedProfile.follow_button.notfollowed_text,
    profileImage: feedProfile.small_photo_url,
    followedText: feedProfile.follow_button.followed_text,
    designerName: feedProfile.follow_button.designer_name,
    productTaxonomy: feedProfile.follow_button.product_taxonomy
  } : null;

  function onAppDownloadBannerClose() {
    dispatch(setDesktopBannerVisible(false));
  }

  return React.createElement("div", {
    className: styles.container
  }, languageIsEnglish() && !desktopAppBannerVisible && !disableDUBanner && showDUBanner && feedProfile && feedProfile.follow_button && feedProfile.follow_button.is_authenticated != "true" && React.createElement(FollowStickyBanner, _extends({
    forceDisplay: showDUBanner
  }, followButtonProps)), cookieBanner && React.createElement(CookieBanner, {
    cookiePolicyUrl: cookieBanner.cookie_policy_url,
    debug: false
  }), React.createElement(AppDownloadBannerDesktop, {
    isOpen: desktopAppBannerVisible,
    onClose: onAppDownloadBannerClose,
    eventLabel: "desktop_banner_feeds"
  }));
}
export default withReduxProvider(connect(mapStateToProps)(BannerContainer));